import type { GridApi } from '@mui/x-data-grid-pro';
import * as React from 'react';
import { setBulkExpansionState } from './bulkExpansionStore';
import { getGroupNodes } from './gridGroupUtils';

export const usePublishBulkExpansionState = (apiRef: React.RefObject<GridApi>): void => {
  React.useEffect(() => {
    const api = apiRef.current;
    if (!api) return;

    const recompute = () => {
      let expandedCount = 0;
      let groupCount = 0;
      for (const node of getGroupNodes(apiRef)) {
        if (node.children?.length) {
          groupCount++;
          if (node.childrenExpanded) expandedCount++;
        }
      }
      setBulkExpansionState(apiRef, {
        allExpanded: groupCount > 0 && expandedCount === groupCount,
        allCollapsed: expandedCount === 0,
      });
    };

    recompute();
    const unsubscribeRowsSet = api.subscribeEvent('rowsSet', recompute);
    const unsubscribeExpansion = api.subscribeEvent('rowExpansionChange', recompute);

    return () => {
      unsubscribeRowsSet();
      unsubscribeExpansion();
    };
  }, [apiRef]);
};
